import { type FeatureModule } from '@store/features/types';
import storage from 'redux-persist/lib/storage'; // localStorage

import featureToggleReducer from './slice';

/**
 * Feature toggle feature module definition
 */
export const featureToggleFeature: FeatureModule = {
  // Basic feature identification
  id: 'feature-rollout-toggle',
  name: 'Feature Rollout Toggle',

  // Feature dependencies (if any)
  dependencies: [], // No dependencies

  // Feature reducers
  reducers: {
    'featureRolloutToggle/preference': featureToggleReducer,
  },

  // No additional middleware (API middleware is registered globally via baseApi)
  middleware: [],

  // Persistence configuration
  persistence: {
    enabled: true,
    storage: storage, // Uses scopedStorage automatically via createScopedStorage wrapper
    whitelist: ['features'], // Only persist the features map
    debounce: 500, // Debounce writes to localStorage
  },

  // Cross-tab sync configuration
  sync: {
    enabled: true,
    whitelist: [
      'featureRolloutToggle/preference/setPreference',
      'featureRolloutToggle/preference/clearPreference',
    ],
  },

  // Feature lifecycle hooks
  setup: _store => {
    // Setup code when feature is registered
  },

  cleanup: _store => {
    // Cleanup code when feature is unregistered
  },
};

/**
 * Initialize feature - call this when registering the feature
 */
export function initializeFeatureToggleFeature() {
  return {
    feature: featureToggleFeature,
  };
}
